<template>
  <v-select
    ref="controlFocoSelectMarca"
    label="Marca*"
    v-model="iModel"
    :items="items"
    item-value="Id_Marca"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectMarca",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        if (valor != undefined && valor != 0) {
          var ind = this.items.findIndex(x => x.Id_Marca == valor);
          this.$emit("seleccionarItem", this.items[ind]);
        }
      }
    }
  },
  created() {
    eventBus.$on("setearFocoSelectMarca", this.setearFoco);
    this.listarItems();
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectMarca", this.setearFoco);
  },
  methods: {
    listarItems() {
      this.loading = true;
      HttpHelper.get("Marca", {
        palabra: ""
      })
        .then(response => {
          this.items = response.data;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    setearFoco() {
      this.$refs.controlFocoSelectMarca.focus();
    }
  }
};
</script>
